import axios from "axios";
import { getAuth } from "firebase/auth";
import { SPECIAL_ERRORS } from "../config/error";
import Analytics, { EVENTS } from "./anayltics";

const FallbackErrorMessage = "Something went wrong! Please try again after some time";
const NETWORK_ERROR_CODE = "ERR_NETWORK";

//TODO: TRY to handle more axios errors like ERR_FAILED, etc.

//Axios does not support body for GET requests
export const get = async (config: any, noAuth?: boolean) => {
	const { url, headers, params, uuid } = config;

	const defaultHeaders: any = {
		Accept: "application/json",
		"Content-Type": "application/json;charset=UTF-8",
	};

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime

		if (!noAuth) {
			const auth = getAuth();
			const accessToken: any = await auth.currentUser?.getIdToken();

			if (!accessToken) {
				console.log(auth);
				console.log("FAiled to Fetch Access Token");
				return { error: "Failed to Fetch Access Token" };
			}

			defaultHeaders["Xook-Access-Token"] = accessToken;
		}

		const options = {
			url: url,
			method: "get",
			params: { ...params, uuid },
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);

		//Handle status code 200 errors;

		if (response.data.error) {
			Analytics.trackEvent(EVENTS.SERVER_ERROR, {
				endpoint: url,
				method: "GET",
				code: response?.data?.error,
				message: response?.data?.message,
			});

			return {
				errorCode: response.data.error,
				error: response.data.message,
			};
		}

		return {
			data: response.data.data,
		};
	} catch (error: any) {
		switch (error?.code) {
			case NETWORK_ERROR_CODE:
				Analytics.trackEvent(EVENTS.CLIENT_ERROR, {
					endpoint: url,
					method: "GET",
					code: NETWORK_ERROR_CODE,
					message: "Network Error",
				});
				return { error: "Network Error", errorCode: SPECIAL_ERRORS.NETWORK_ERROR };

			default:
				Analytics.trackEvent(EVENTS.SERVER_ERROR, {
					endpoint: url,
					method: "GET",
					code: error?.response?.data?.error,
					message: error?.response?.data?.message,
				});
				return {
					error: error?.response?.data?.message || FallbackErrorMessage,
					errorCode: error.code,
					metadata: error?.response?.data?.metadata,
				};
		}
	}
};

export const post = async (config: any, noAuth?: boolean) => {
	const { url, headers, data, uuid, params } = config;

	const defaultHeaders: any = {
		Accept: "application/json",
		"Content-Type": "application/json;charset=UTF-8",
	};

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		if (!noAuth) {
			const auth = getAuth();
			const accessToken: any = await auth.currentUser?.getIdToken();

			if (!accessToken) {
				console.log(auth);
				console.log("FAiled to Fetch Access Token");
				return { error: "Failed to Fetch Access Token" };
			}

			defaultHeaders["Xook-Access-Token"] = accessToken;
		}

		const options = {
			url: url,
			method: "post",
			data: data,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
			params: {
				uuid, ...params
			},
		};

		const response = await axios(options);

		if (response.data.error) {
			Analytics.trackEvent(EVENTS.SERVER_ERROR, {
				endpoint: url,
				method: "POST",
				code: response?.data?.error,
				message: response?.data?.message,
			});

			return {
				errorCode: response.data.error,
				error: response.data.message,
			};
		}

		return {
			data: response.data.data,
		};

	} catch (error: any) {
		switch (error.code) {
			case NETWORK_ERROR_CODE:
				Analytics.trackEvent(EVENTS.CLIENT_ERROR, {
					endpoint: url,
					method: "POST",
					code: NETWORK_ERROR_CODE,
					message: "Network Error",
				});
				return { error: "Network Error", errorCode: SPECIAL_ERRORS.NETWORK_ERROR };

			default:
				Analytics.trackEvent(EVENTS.SERVER_ERROR, {
					endpoint: url,
					method: "POST",
					code: error?.response?.data?.error,
					message: error?.response?.data?.message,
				});
				return {
					error: error?.response?.data?.message || FallbackErrorMessage,
					errorCode: error.code,
					metadata: error?.response?.data?.metadata,
				};
		}
	}
};
